/* eslint-disable max-len */

import React from 'react';

export const Package = () => {
  return (
    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="package">
        <path
          id="Icon"
          d="M11.9583 4.24569L6.99998 7.00032M6.99998 7.00032L2.04165 4.24569M6.99998 7.00032L7 12.542M12.25 9.36782V4.63284C12.25 4.43297 12.25 4.33303 12.2206 4.2439C12.1945 4.16505 12.1519 4.09266 12.0956 4.0316C12.032 3.96257 11.9447 3.91403 11.7699 3.81696L7.45327 1.41882C7.28783 1.32691 7.20511 1.28095 7.11751 1.26294C7.03998 1.24699 6.96002 1.24699 6.88249 1.26294C6.79489 1.28095 6.71217 1.32691 6.54673 1.41882L2.23007 3.81696C2.05534 3.91403 1.96798 3.96257 1.90437 4.0316C1.84809 4.09267 1.8055 4.16505 1.77945 4.2439C1.75 4.33303 1.75 4.43297 1.75 4.63284V9.36782C1.75 9.5677 1.75 9.66764 1.77945 9.75677C1.8055 9.83562 1.84809 9.908 1.90437 9.96907C1.96798 10.0381 2.05534 10.0866 2.23007 10.1837L6.54673 12.5819C6.71217 12.6738 6.79489 12.7197 6.88249 12.7377C6.96002 12.7537 7.03998 12.7537 7.11751 12.7377C7.20511 12.7197 7.28783 12.6738 7.45327 12.5819L11.7699 10.1837C11.9447 10.0866 12.032 10.0381 12.0956 9.96907C12.1519 9.908 12.1945 9.83562 12.2206 9.75677C12.25 9.66764 12.25 9.5677 12.25 9.36782Z"
          stroke="#101828"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          id="Icon_2"
          d="M9.625 5.54167L4.375 2.625"
          stroke="#101828"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  );
};
